export default {
  resolve (instance) {
    return [
      {
        icon: 'fa-book',
        title: instance.$t('other'),
        children: [
          {
            title: instance.$t('policy'),
            to: 'policy'
          }
        ],
        displayOrder: 9001
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/common/menus.js